(() => {
  const SELECTOR = '.js-anim-typewriter, .js-anim-rolling, .js-anim-appearing';
  const observedRoots = new WeakSet();

  const getRequirements = (root = document) => ({
    typewriter: Boolean(
      root.matches?.('.js-anim-typewriter') ||
        root.querySelector?.('.js-anim-typewriter'),
    ),
    gsap: Boolean(
      root.matches?.('.js-anim-rolling, .js-anim-appearing') ||
        root.querySelector?.('.js-anim-rolling, .js-anim-appearing'),
    ),
    any: Boolean(root.matches?.(SELECTOR) || root.querySelector?.(SELECTOR)),
  });

  const initialize = async (root = document) => {
    const requirements = getRequirements(root);
    if (!requirements.any) return false;

    const assets = window.themeAssets;
    if (!assets) {
      throw new Error('El cargador de assets del tema no está disponible.');
    }

    const dependencies = [];
    if (requirements.typewriter) dependencies.push(assets.loadTypewriter());
    if (requirements.gsap) dependencies.push(assets.loadGsap());

    await Promise.all(dependencies);
    await assets.loadScript('animated-titles-runtime.js');
    window.JDAnimatedTitles?.init(root);
    return true;
  };

  const safeInitialize = (root) => {
    initialize(root).catch((error) => {
      console.error('No fue posible inicializar los títulos animados.', error);
    });
  };

  window.loadAnimatedTitles = initialize;

  const observe = (root = document.documentElement) => {
    if (!root || observedRoots.has(root) || typeof MutationObserver !== 'function') {
      return;
    }

    observedRoots.add(root);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (getRequirements(node).any) {
            safeInitialize(node);
            return;
          }
        }
      }
    });

    observer.observe(root, { childList: true, subtree: true });
  };

  const start = () => {
    safeInitialize(document);
    observe();

    document.addEventListener('shopify:section:load', (event) => {
      safeInitialize(event.target);
    });
  };

  if (window.themeAssets) start();
  else window.addEventListener('theme:assets:ready', start, { once: true });
})();
